import * as React from 'react';
import { MouseEventHandler, useState } from 'react';

interface SidebarProps {
	open: boolean;
	sidebarHandler: any;
	children: any;
	menuItems: Array<{ text: string; href: string; active: boolean }>;
}
const Sidebar: React.FC<SidebarProps> = (props: SidebarProps) => {
	const [touchStart, setTouchStart] = useState(null);
	const [touchEnd, setTouchEnd] = useState(null);

	// the required distance between touchStart and touchEnd to be detected as a swipe
	const minSwipeDistance = 50;

	const onTouchStart = (e: any) => {
		setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
		setTouchStart(e.targetTouches[0].clientX);
	};

	const onTouchMove = (e: any) => setTouchEnd(e.targetTouches[0].clientX);

	const onTouchEnd = () => {
		if (!touchStart || !touchEnd) return;
		const distance = touchStart - touchEnd;
		const isLeftSwipe = distance > minSwipeDistance;
		const isRightSwipe = distance < -minSwipeDistance;
		if (isRightSwipe) {
			props.sidebarHandler();
		}
	};
	return (
		<>
			<aside
				className={props.open ? 'w-64' : 'w-0'}
				aria-label={'Sidebar'}
				onTouchStart={onTouchStart}
				onTouchMove={onTouchMove}
				onTouchEnd={onTouchEnd}
			>
				<div
					className={[
						'fixed top-0 right-0 left-0 bottom-0 bg-black opacity-50',
						props?.open ? '' : 'invisible'
					].join(' ')}
					onClick={props.sidebarHandler}
				/>
				<div
					className={[
						'fixed top-0 right-0 z-50 h-full overflow-y-auto transition-all',
						props.open ? 'w-64 opacity-100' : 'w-0 opacity-0'
					].join(' ')}
				>
					<div
						className={
							'h-full overflow-y-auto bg-white px-3 py-4 shadow'
						}
					>
						<ul className="space-y-2">
							{props.menuItems.map((item) => {
								return (
									<li>
										<a
											href={item.href}
											className={
												'flex items-center rounded-lg p-2 py-3 font-rubik text-base font-bold text-bt-blue hover:text-bt-red'
											}
										>
											<span className={'ml-3'}>
												{item.text}
											</span>
										</a>
									</li>
								);
							})}
						</ul>
					</div>
				</div>
			</aside>
			{props.children}
		</>
	);
};

export default Sidebar;
